export const routes = [
  ...require('./balanceComponentGroup/routes').routes
]
